export default {
    props: {
        fields: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            localFields: [],
        }
    },
    mounted() {
        this.formatFields();
    },
    methods: {
        formatFields() {
            let tempList = [];
            if (this.fields) {
                for (let item of this.fields) {
                    if (item.optionsFromDict) {
                        this.$store.dispatch('dictionaryEnumStore/queryDictionary', item.optionsFromDict);
                    }
                    if (item.name) {
                        item.key = item.name;
                    }
                    tempList.push(item);
                }
            }
            this.localFields = tempList;
        },
        getOptions(item) {
            if (item.optionsFromDict) {
                return this.$store.getters['dictionaryEnumStore/getOptions'](item.optionsFromDict);
            }
            if (this.$store.state.dictionaryEnumStore.reloadFlag) {
                //
            }
            return item.options;
        },
    }
}
